export function mustGetElementById<T extends HTMLElement>(id: string): T {
  const elementOrNull = document.getElementById(id) as T | null;
  if (elementOrNull === null) throw new Error(id + ' is missing in the document');
  return elementOrNull;
}

export function mustQuerySelectorAtIndex<T extends HTMLElement>(
  selector: string,
  index: number,
  nameForError: string
): T {
  const elements = document.querySelectorAll(selector);
  const elementOrNull = elements.item(index) as T | null;
  if (elementOrNull === null) throw new Error(nameForError + ' is missing in the document');
  return elementOrNull;
}

export const isVisible = (el: HTMLElement) => {
  do {
    if (el.getAttribute('aria-hidden') === 'true') return false;
    el = el.parentElement!;
  } while (el.id !== 'api');
  return true;
}

export const getVisibleTextContent = (el: HTMLElement) => ((isVisible(el) && el.textContent) || '').trim();

export function mustGetElementByName<T extends HTMLElement>(name: string): T {
  const elementOrNull = document.getElementsByName(name)[0] as T | null; // assume there is only one item with this name
  if (elementOrNull === null) throw new Error(name + ' is missing in the document');
  return elementOrNull;
}

export function constructLogoutUri(url: string): string {
  let templateUrl =
      "https://{version}sso.mysgi.ca/{tenant}.onmicrosoft.com/{policy}/oauth2/v2.0/logout?post_logout_redirect_uri=https://{env}verify.sgicloud.ca";

    // example of url being avaialable at this tiem: https://npd.sso.mysgi.ca/sgib2cnpd.onmicrosoft.com/B2C_1A_SignIn_MFA/api/CombinedSigninAndSignup/confirmed?r.....
    //                                                                                                        <---- policy --->
    let components = url.split("/");
    let policy = components[4];

    templateUrl = templateUrl.replaceAll("{policy}", policy);

    if (url.includes("sgib2cnpd")) {
      templateUrl = templateUrl.replaceAll("{tenant}", "sgib2cnpd").replace("{env}", "int.").replace("{version}", "npd.");
    } else if (url.includes("sgib2csnd")) {
      templateUrl = templateUrl.replaceAll("{tenant}", "sgib2csnd").replace("{env}", "int.").replace("{version}", "snd.");
    } else if (url.includes("sgib2cprd")) {
      templateUrl = templateUrl.replaceAll("{tenant}", "sgib2cprd").replace("{env}", "").replace("{version}", "");
    }

    return templateUrl;
}